const crypto = require('crypto')
import * as _ from 'lodash'
import { format, addMonths, startOfMonth } from 'date-fns';
import { HttpRequest } from '../../util/http';
import { IAvid } from '../avids/interfaces';
import { IHierarchy, IHierarchyStudy } from '../hierarchies/interfaces';
import { ISegment } from '../segments/interfaces';
import { IStudy } from '../studies/interfaces';

export interface IGetAllResponse<T> {
  values: T
}

export const loadGetAll = <T>(endpoint: string, data?: any) => {
  const method = 'POST'

  return HttpRequest.fetch<IGetAllResponse<T[]>>(endpoint, { method, data }).then((res) => res.values)
}

export const GetAllAvids = () => {
  return loadGetAll<IAvid>('/scripts/avids/avids_get_all')
}

export const GetAllSegments = () => {
  const method = 'POST'
  const endpoint = '/scripts/segments/get_all'

  return HttpRequest.fetch<ISegment[]>(endpoint, { method })
}

export const GetAllHierarchies = () => {
  return loadGetAll<IHierarchy>('/scripts/hierarchies/get_all')
}

export const GetAllStudies = () => {
  return loadGetAll<IStudy>('/scripts/studies/get_all')
}

export const GetAllHierarchyStudies = () => {
  return loadGetAll<IHierarchyStudy>('/scripts/hierarchies_studies/get_all')
}

const getSignatureKey = (Crypto, key, dateStamp, regionName, serviceName) => {
  const kDate = signString(dateStamp, 'AWS4' + key);
  const kRegion = signString(regionName, kDate);
  const kService = signString(serviceName, kRegion);
  const kSigning = signString('aws4_request', kService);
  return kSigning;
}

const signString = (key, message) => {
  return crypto.createHmac('sha256', key).update(message)
}

export const getApiGatewaySignature = (accessKey, secretKey, payload) => {
  const method = 'POST'
  const service = 'execute-api'
  const host = 'zu6g20fbq6.execute-api.us-east-1.amazonaws.com'
  const region = 'us-east-1'
  const endpoint = '/Dev/testrunreport'
  const canonicalUri = 'https://zu6g20fbq6.execute-api.us-east-1.amazonaws.com/Dev/testrunreport'
  const amzDate = format(new Date(), 'yyyyMMdd\'T\'HHmmss\'Z\'');
  const datestamp = format(new Date(), 'yyyyMMdd');



  const canonicalHeaders = 'host: ' + host + '\n'
  const signedHeaders = 'host'

  const algorithm = 'AWS4-HMAC-SHA256'
  const credentialScope = datestamp + '/' + region + '/' + service + '/' + 'aws4_request'

  let canonicalQuerystring = endpoint
  canonicalQuerystring += '&X-Amz-Algorithm=AWS4-HMAC-SHA256'
  canonicalQuerystring += '&X-Amz-Credential=' + encodeURI(accessKey + '/' + credentialScope)
  canonicalQuerystring += '&X-Amz-Date=' + amzDate
  canonicalQuerystring += '&X-Amz-Expires=30'
  canonicalQuerystring += '&X-Amz-SignedHeaders=' + signedHeaders

  const payloadHash = signString(payload, payload).digest('hex')

  const canonicalRequest = method + '\n' + canonicalUri + '\n' + canonicalQuerystring + '\n' + canonicalHeaders + '\n' + signedHeaders + '\n' + payloadHash

  const stringToSign = algorithm + '\n' + amzDate + '\n' + credentialScope + '\n' + signString(canonicalRequest, '').digest('hex')

  const signingKey = getSignatureKey(crypto, secretKey, datestamp, 'us-east-1', 'execute-api')
  return signString(signingKey, stringToSign).digest('hex')
}

/**
 * getInitialDateRange() returns an initial date range
 * that corresponds to the current month:
 * start of the current month - current date
 */
export const getInitialDateRange = () => {
  const firstCurrentMonthDate = 1
  const currentDate = new Date()
  const initialDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), firstCurrentMonthDate)
  const fromDate = format(initialDate, 'yyyy/MM/dd');
  const toDate = format(currentDate, 'yyyy/MM/dd');



  return `${fromDate}-${toDate}`
}

/**
 * getPreviousDateRange() returns a previous date range
 * that corresponds to one month before upperLimit passed:
 * start of the past month - upperLimit
 * @param upperLimit String representing a date in the YYYY/MM/DD format
 */
export const getPreviousDateRange = (upperLimit: string) => {
  if (upperLimit && upperLimit.length > 0) {
    const currentDate = new Date()
    const initialDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate())
    const fromDate = format(initialDate, 'yyyy/MM/dd');
    return `${fromDate}-${upperLimit}`
  } else {
    return getInitialDateRange()
  }
}
